const gerar_previsao_de_rendimento = [
  {
    path: "/gerar-previsao-de-rendimento",
    redirect: "/gerar-previsao-de-rendimento",
    meta: {
      breadCrumb: "Planejamento de Matrícula - Previsão de Rendimento",
    },
    children: [
      {
        path: "/gerar-previsao-de-rendimento",
        name: "/gerar-previsao-de-rendimento",
        component: () =>
          import(
            "@/views/GerarPrevisaoDeRendimentoEscolar/GerarPrevisaoDeRendimentoEscolar.vue"
          ),
      },
    ],
  },
  {
    path: "/consultar-previsao-de-rendimento",
    redirect: "/consultar-previsao-de-rendimento",
    meta: {
      breadCrumb: "Planejamento de Matrícula - Previsão de Rendimento",
    },
    children: [
      {
        path: "/consultar-previsao-de-rendimento",
        name: "/consultar-previsao-de-rendimento",
        component: () =>
          import(
            "@/views/ConsultaPrevisaoDeRendimento/ConsultaPrevisaoDeRendimento.vue"
          ),
      },
    ],
  },
];

export { gerar_previsao_de_rendimento };
